import Scrollbar from 'smooth-scrollbar';
import AOS from 'aos'

const animations = {
  scroll_init: function () {
    let scrollbar = Scrollbar.init(document.querySelector('#scroll-content'));

    if (window.innerWidth > 991) {
      AOS.init();
    }

    AOS.init({disable: 'mobile'});

    [].forEach.call(document.querySelectorAll('[data-aos]'), (el) => {
      scrollbar.addListener(() => {
        if (scrollbar.isVisible(el)) {
          setTimeout(() => {
            el.classList.add('aos-animate')
          }, 500);
        }
      });
    });

    let links = document.querySelectorAll('.intro a[href^="#"]')

    links.forEach(function (el) {
      el.addEventListener('click', () => {
        let href = el.getAttribute('href')
        let anchor = document.querySelector(href);
        if (anchor) {
          let scrollToHere = anchor.offsetTop;
          scrollbar.scrollTo(0, scrollToHere, 1000);
        }
      });
    });

    let lines = document.querySelectorAll('.title__line')

    lines.forEach(function (el) {
      el.addEventListener('click', () => {
        let scrollToHere = el.parentElement.parentElement.parentElement.offsetTop + 30;
        scrollbar.scrollTo(0, scrollToHere, 1000);
      });
    });

    let accordion = document.querySelectorAll('.accordion-item__shown')

    accordion.forEach(function(el) {
      el.addEventListener('click', function() {
        if (! el.parentElement.classList.contains('accordion-item_open')) {
          scrollbar.scrollTo(0, el.parentElement.offsetTop, 1700);
        }
        setTimeout(function() {
          let scrollToHere = el.parentElement.offsetTop;
          scrollbar.scrollTo(0, scrollToHere, 700);
        }, 700)
      })
    });
  },

  fixed_button: function () {

    const buttonEl = document.querySelector('.footer__button');
    let scrollbar = Scrollbar.init(document.querySelector('#scroll-content'));
    buttonEl.addEventListener('click', function () {
      scrollbar.scrollIntoView(document.querySelector('.hero'));
    })
  },

  destroy_scroll: function () {
    Scrollbar.destroy(document.querySelector('#scroll-content'))
  },

}

animations.scroll_init();
animations.fixed_button();

export default animations
